'use client';
import React from 'react';
import { cn } from '@/app/lib/utils';

import AndroidIcon from '../icons/android.svg';
import AddCompanyIcon from '../icons/add-company.svg';
import EnrichCompanyIcon from '../icons/enrich-company.svg';
import EnrichCompanyTickIcon from '../icons/enrich-company-tick.svg';
import AccountCircleFillIcon from '../icons/account-circle-fill.svg';
import AIGenerateIcon from '../icons/ai-generate.svg';
import AISummaryIcon from '../icons/ai-summary-icon.svg';
import AnchorLineIcon from '../icons/anchor-line.svg';
import ArrowDownSFillIcon from '../icons/arrow-down-s-fill.svg';
import ArrowLeftSLineIcon from '../icons/arrow-left-s-line.svg';
import ArrowRightDownLineIcon from '../icons/arrow-right-down-line.svg';
import ArrowRightUpLineIcon from '../icons/arrow-right-up-line.svg';
import ArrowUpDoubleLineIcon from '../icons/arrow-up-double-line.svg';
import ArrowDownSLineIcon from '../icons/arrow-down-s-line.svg';
import AttachmentIcon from '../icons/attachment.svg';
import ArchiveLineIcon from '../icons/archive-line.svg';
import ArchiveFillIcon from '../icons/archive-fill.svg';
import ArrowGoBackLineIcon from '../icons/arrow-go-back-line.svg';
import ArrowGoForwardLineIcon from '../icons/arrow-go-forward-line.svg';
import BarChartIcon from '../icons/bar-chart.svg';
import BardFillIcon from '../icons/bard-fill.svg';
import BellIcon from '../icons/bell.svg';
import BookOpenIcon from '../icons/book-open.svg';
import Book3LineIcon from '../icons/book-3-line.svg';
import BookLineIcon from '../icons/book-line.svg';
import BookReadLineIcon from '../icons/book-read-line.svg';
import Box3LineIcon from '../icons/box-3-line.svg';
import BankLineIcon from '../icons/bank-line.svg';
import BraveIcon from '../icons/brave.svg';
import BuildingLineIcon from '../icons/building-line.svg';
import Building3LineIcon from '../icons/building-3-line.svg';
import Building4LineIcon from '../icons/building-4-line.svg';
import Building4LineAltIcon from '../icons/building-4-line-alt.svg';
import Building4FillIcon from '../icons/building-4-fill.svg';
import Briefcase4LineIcon from '../icons/briefcase-4-line.svg';
import CalendarIcon from '../icons/calendar.svg';
import CalendarCheckFillIcon from '../icons/calendar-check-fill.svg';
import CalendarEventFillIcon from '../icons/calendar-event-fill.svg';
import CalendarEventLineIcon from '../icons/calendar-event-line.svg';
import CalendarFillIcon from '../icons/calendar-fill.svg';
import CalendarLineIcon from '../icons/calendar-line.svg';
import CalendarScheduleLineIcon from '../icons/calendar-schedule-line.svg';
import CalendarScheduleFillIcon from '../icons/calendar-schedule-fill.svg';
import CalendarCheckLineIcon from '../icons/calendar-check-line.svg';
import CalendarTodoLineIcon from '../icons/calendar-todo-line.svg';
import Calendar2LineIcon from '../icons/calendar-2-line.svg';
import CashLineIcon from '../icons/cash-line.svg';
import ChatIcon from '../icons/chat.svg';
import Chat4LineIcon from '../icons/chat-4-line.svg';
import Chat3LineIcon from '../icons/chat-3-line.svg';
import ChatCheckFillIcon from '../icons/chat-check-fill.svg';
import ChatGptIcon from '../icons/chatgpt.svg';
import ChatHistoryLineIcon from '../icons/chat-history-line.svg';
import ChatNewLineIcon from '../icons/chat-new-line.svg';
import ChatStarIcon from '../icons/chat-star.svg';
import ChartLegendDotIcon from '../icons/chart-legend-dot.svg';
import ChatUnreadLineIcon from '../icons/chat-unread-line.svg';
import ChatSettingsLineIcon from '../icons/chat-settings-line.svg';
import CheckIcon from '../icons/check.svg';
import CheckDoubleFillIcon from '../icons/check-double-fill.svg';
import CheckCircleFillIcon from '../icons/checkbox-circle-fill.svg';
import ChevronDownLineIcon from '../icons/chevron-down.svg';
import ChevronRightIcon from '../icons/chevron-right.svg';
import ChromeIcon from '../icons/chrome.svg';
import CodeLineIcon from '../icons/code-line.svg';
import ComputerLineIcon from '../icons/computer-line.svg';
import ComputerFillIcon from '../icons/computer-fill.svg';
import ContactsLineIcon from '../icons/contacts-line.svg';
import ContactsBook2LineIcon from '../icons/contacts-book-2-line.svg';
import CollapseDiagonalLineIcon from '../icons/collapse-diagonal-line.svg';
import CrossFillIcon from '../icons/cross-fill.svg';
import CrossHairLineIcon from '../icons/crosshair-line.svg';
import CloseCircleLineIcon from '../icons/close-circle-line.svg';
import CloseCircleFillIcon from '../icons/close-circle-fill.svg';
import CursorFillIcon from '../icons/cursor-fill.svg';
import CurrencyFillIcon from '../icons/currency-fill.svg';
import DatabaseLineIcon from '../icons/database-line.svg';
import DeleteIcon from '../icons/delete.svg';
import DotIcon from '../icons/dot.svg';
import DotLargeIcon from '../icons/dot-large.svg';
import DonutChartLineIcon from '../icons/donut-chart-line.svg';
import DraftIcon from '../icons/mail-send-fill.svg';
import EditBoxLineIcon from '../icons/edit-box-line.svg';
import EllipseIcon from '../icons/ellipse.svg';
import EyeLineIcon from '../icons/eye-line.svg';
import EyeChatIcon from '../icons/eye-chat.svg';
import EdgeIcon from '../icons/edge.svg';
import FacebookFilledIcon from '../icons/facebook-filled.svg';
import FacebookFillIcon from '../icons/facebook-fill.svg';
import TwitterFillIcon from '../icons/twitter-fill.svg';
import FirefoxIcon from '../icons/firefox.svg';
import FileLineIcon from '../icons/file-line.svg';
import FolderLineIcon from '../icons/folder-line.svg';
import ForbidFillIcon from '../icons/forbid-fill.svg';
import Forbid2LineIcon from '../icons/forbid-2-line.svg';
import Focus2LineIcon from '../icons/focus-2-line.svg';
import Focus2FillIcon from '../icons/focus-2-fill.svg';
import File2LineIcon from '../icons/file-2-line.svg';
import FileAddLineIcon from '../icons/file-add-line.svg';
import FileChartLineIcon from '../icons/file-chart-line.svg';
import FileCopyLineIcon from '../icons/file-copy-line.svg';
import FlagLineIcon from '../icons/flag-line.svg';
import FlagFillIcon from '../icons/flag-fill.svg';
import FlashlightLineIcon from '../icons/flashlight-line.svg';
import FlowChartIcon from '../icons/flow-chart.svg';
import FullScreenLineIcon from '../icons/full-screen-line.svg';
import GeminiIcon from '../icons/gemini.svg';
import GlobalLineIcon from '../icons/global-line.svg';
import GlobalFillIcon from '../icons/global-fill.svg';
import GoogleCalendarIcon from '../icons/g-calendar.svg';
import GmailIcon from '../icons/gmail.svg';
import GoogleIcon from '../icons/google.svg';
import OutlookIcon from '../icons/outlook.svg';
import Group3FillIcon from '../icons/group-3-fill.svg';
import HandCoinLineIcon from '../icons/hand-coin-line.svg';
import HelpCenterIcon from '../icons/help-center.svg';
import HomeLineIcon from '../icons/home-line.svg';
import IndustryFillIcon from '../icons/industry-fill.svg';
import IndeterminateCircleFillIcon from '../icons/indeterminate-circle-fill.svg';
import IntermediateCircleLineIcon from '../icons/intermediate-circle-line.svg';
import IosIcon from '../icons/ios.svg';
import LinkedinIcon from '../icons/linkedin.svg';
import LinkedinFilledIcon from '../icons/linkedin-filled.svg';
import LinkedinColorIcon from '../icons/linkedin-color.svg';
import LinuxIcon from '../icons/linux.svg';
import ListCheck2Icon from '../icons/list-check-2.svg';
import LoadingIcon from '../icons/loading.svg';
import Loader2FillIcon from '../icons/loader-2-fill.svg';
import LockIcon from '../icons/lock.svg';
import LockLineIcon from '../icons/lock-line.svg';
import LockUnlockLineIcon from '../icons/lock-unlock-line.svg';
import LogoutIcon from '../icons/logout.svg';
import LoginBoxLineIcon from '../icons/login-box-line.svg';
import LogoutBoxFillIcon from '../icons/logout-box-fill.svg';
import LogoutBoxRFillIcon from '../icons/logout-box-r-fill.svg';
import LogoSidebarIcon from '../icons/logo-sidebar.svg';
import LogoNavIcon from '../icons/logo-nav.svg';
import LogoSquareIcon from '../icons/square-logo.svg';
import LoopRightLineIcon from '../icons/loop-right-line.svg';
import MacIcon from '../icons/mac.svg';
import MailIcon from '../icons/mail.svg';
import MailFillIcon from '../icons/mail-fill.svg';
import MailForbidFillIcon from '../icons/mail-forbid-line.svg';
import MailLineIcon from '../icons/mail-line.svg';
import MailStarLineIcon from '../icons/mail-star-line.svg';
import MailAddLineIcon from '../icons/mail-add-line.svg';
import MailCheckLineIcon from '../icons/mail-check-line.svg';
import MailDownloadLineIcon from '../icons/mail-download-line.svg';
import MailCloseLineIcon from '../icons/mail-close-line.svg';
import MailSendLineIcon from '../icons/mail-send-line.svg';
import MenuSearchLineIcon from '../icons/menu-search-line.svg';
import MapFillIcon from '../icons/map-fill.svg';
import MapPinLineIcon from '../icons/map-pin-line.svg';
import MapPin2LineIcon from '../icons/map-pin-2-line.svg';
import MicrosoftIcon from '../icons/microsoft.svg';
import More2LineIcon from '../icons/more-2-line.svg';
import MoneyDollarCircleLineIcon from '../icons/money-dollar-circle-line.svg';
import OnboaringIcon from '../icons/onboaring.svg';
import OperaIcon from '../icons/opera.svg';
import P2pLineIcon from '../icons/p2p-line.svg';
import PagesLineIcon from '../icons/pages-line.svg';
import ParentLineIcon from '../icons/parent-line.svg';
import PauseLineIcon from '../icons/pause-line.svg';
import PauseFillIcon from '../icons/pause-fill.svg';
import PerplexityIcon from '../icons/perplexity.svg';
import PhoneIcon from '../icons/phone.svg';
import PhoneFillIcon from '../icons/phone-fill.svg';
import PlanetLineIcon from '../icons/planet-line.svg';
import PlayLineIcon from '../icons/play-line.svg';
import PlayFillIcon from '../icons/play-fill.svg';
import PlayLargeFillIcon from '../icons/play-large-fill.svg';
import PriceTag2LineIcon from '../icons/price-tag-2-line.svg';
import PriceTag2FillIcon from '../icons/price-tag-2-fill.svg';
import Progress2LineIcon from '../icons/progress-2-line.svg';
import Puzzle2LineIcon from '../icons/puzzle-2-line.svg';
import Prohibited2FillIcon from '../icons/prohibited-2-fill.svg';
import QuestionAnswerFillIcon from '../icons/question-answer-fill.svg';
import QuestionLineIcon from '../icons/question-line.svg';
import RectangleLineIcon from '../icons/rectangle-line.svg';
import ReplyLineIcon from '../icons/reply-line.svg';
import ReplyAllLineIcon from '../icons/reply-all-line.svg';
import RepeatLineIcon from '../icons/repeat-line.svg';
import SafariIcon from '../icons/safari.svg';
import SearchIcon from '../icons/search.svg';
import SearchLineIcon from '../icons/search-line.svg';
import ShareForwardLineIcon from '../icons/share-forward-line.svg';
import SendPlaneLineIcon from '../icons/send-plane-line.svg';
import SettingsIcon from '../icons/settings-2-line.svg';
import Settings2LineIcon from '../icons/settings-2-line.svg';
import SettingsUserIcon from '../icons/settings-user.svg';
import ShakehandIcon from '../icons/shakehand.svg';
import ShapesFillIcon from '../icons/shapes-fill.svg';
import SlackIcon from '../icons/slack.svg';
import SlackLogoIcon from '../icons/slack-logo.svg';
import SpeakAIIcon from '../icons/speak-ai-line.svg';
import SpyLineIcon from '../icons/spy-line.svg';
import StarFillIcon from '../icons/star-fill.svg';
import Store3FillIcon from '../icons/store-3-fill.svg';
import SquareLineIcon from '../icons/square-line.svg';
import SquareFillIcon from '../icons/square-fill.svg';
import SurveyLineIcon from '../icons/survey-line.svg';
import SimpleLoaderIcon from '../icons/simple-loader.svg';
import SignalTowerIcon from '../icons/signal-tower-line.svg';
import SelectBoxCircleLineIcon from '../icons/select-box-circle-line.svg';
import TodoLineIcon from '../icons/todo-line.svg';
import TeamLineIcon from '../icons/team-line.svg';
import TargetIcon from '../icons/target.svg';
import TaskLineIcon from '../icons/task-line.svg';
import TimeFillIcon from '../icons/time-fill.svg';
import TrophyFillIcon from '../icons/trophy-fill.svg';
import User6LineIcon from '../icons/user-6-line.svg';
import User2FillIcon from '../icons/user-2-fill.svg';
import User3FillIcon from '../icons/user-3-fill.svg';
import UserAddLineIcon from '../icons/user-add-line.svg';
import UserSearchLineIcon from '../icons/user-search-line.svg';
import UserMinusLineIcon from '../icons/user-minus-line.svg';
import UserSettingsLineIcon from '../icons/user-settings-line.svg';
import VerifiedFillIcon from '../icons/verified-fill.svg';
import EmotionSadLineIcon from '../icons/emotion-sad-line.svg';
import WebhookLogoIcon from '../icons/webhook-logo.svg';
import WindowsIcon from '../icons/windows.svg';
import WindowsFillIcon from '../icons/windows-fill.svg';
import NewChatIcon from '../icons/new-chat.svg';
import HistoryIcon from '../icons/history.svg';
import MicIcon from '../icons/mic.svg';
import VoicePrintIcon from '../icons/voice-print.svg';
import AddFillIcon from '../icons/add-fill.svg';
import UploadCloudLineIcon from '../icons/upload-cloud-line.svg';
import SelectBoxIcon from '../icons/select-box-multiple.svg';
import SelectBoxLineIcon from '../icons/select-box-line.svg';
import SelectBoxCircleFillIcon from '../icons/select-box-circle-fill.svg';
import SlackFilledIcon from '../icons/slack-filled.svg';
import ShuffleLineIcon from '../icons/shuffle-line.svg';
import ArrowUpIcon from '../icons/arrow-up.svg';
import StopFillIcon from '../icons/stop-fill.svg';
import BrainLineIcon from '../icons/brain-line.svg';
import ChatForwardLineIcon from '../icons/chat-forward-line.svg';
import CoinFillIcon from '../icons/coin-fill.svg';
import CustomerServiceFillIcon from '../icons/customer-service-fill.svg';
import MacFillIcon from '../icons/mac-fill.svg';
import ArrowClockwiseIcon from '../icons/arrow-clockwise.svg';
import ArrowCounterClockwiseIcon from '../icons/arrow-counterclockwise.svg';
import ArrowRightLongFillIcon from '../icons/arrow-right-long-fill.svg';
import JournalTextIcon from '../icons/journal-text.svg';
import JustifyIcon from '../icons/justify.svg';
import TextCenterIcon from '../icons/text-center.svg';
import TextLeftIcon from '../icons/text-left.svg';
import TextRightIcon from '../icons/text-right.svg';
import TextParagraphIcon from '../icons/text-paragraph.svg';
import Timer2LineIcon from '../icons/timer-2-line.svg';
import TypeBoldIcon from '../icons/type-bold.svg';
import TypeItalicIcon from '../icons/type-italic.svg';
import TypeStrikethroughIcon from '../icons/type-strikethrough.svg';
import TypeUnderlineIcon from '../icons/type-underline.svg';
import TextIcon from '../icons/text.svg';
import LinkIcon from '../icons/link.svg';
import FileDocIcon from '../icons/file-doc.svg';
import FileDocxIcon from '../icons/file-docx.svg';
import FilePdfIcon from '../icons/file-pdf.svg';
import FileJpgIcon from '../icons/file-jpg.svg';
import FilePngIcon from '../icons/file-png.svg';
import InformationFillIcon from '../icons/information-fill.svg';
import Building3FillIcon from '../icons/building-3-fill.svg';
import UserFillIcon from '../icons/user-fill.svg';
import userShared2Fill from '../icons/user-shared-2-fill.svg';
import ArrowLeftLineIcon from '../icons/arrow-left-line.svg';
import PencilFillIcon from '../icons/pencil-fill.svg';
import PencilLineEmailIcon from '../icons/pencil-line-email.svg';
import FileCsvIcon from '../icons/file-csv.svg';
import FileGifIcon from '../icons/file-gif.svg';
import FileMovIcon from '../icons/file-mov.svg';
import FileMp4Icon from '../icons/file-mp4.svg';
import FilePptIcon from '../icons/file-ppt.svg';
import FilePptxIcon from '../icons/file-pptx.svg';
import FileTxtIcon from '../icons/file-txt.svg';
import FileXlsIcon from '../icons/file-xls.svg';
import FileXlsxIcon from '../icons/file-xlsx.svg';
import FileZipIcon from '../icons/file-zip.svg';
import UploadCloud2LineIcon from '../icons/upload-cloud-2-line.svg';
import FileTextLineIcon from '../icons/file-text-line.svg';
import XFilledIcon from '../icons/x-filled.svg';
import Filter3FillIcon from '../icons/filter-3-fill.svg';
import CrossHair2Icon from '../icons/cross-hair-2.svg';
import NodeTreeIcon from '../icons/node-tree.svg';
import ShakehandFillIcon from '../icons/shakehand-fill.svg';
import QuestionAnswerLineIcon from '../icons/question-answer-line.svg';
import DoubleQuotesLIcon from '../icons/double-quotes-l.svg';
import AIGenerate2Icon from '../icons/ai-generate-2.svg';
import Apps2LineIcon from '../icons/apps-2-line.svg';
import Apps2AddLineIcon from '../icons/apps-2-add-line.svg';
import LayoutGridLineIcon from '../icons/layout-grid-line.svg';
import MailUploadLineIcon from '../icons/mail-upload-line.svg';
import MailUploadFillIcon from '../icons/mail-upload-fill.svg';
import RefreshLineIcon from '../icons/refresh-line.svg';
import SubtractFillIcon from '../icons/subtract-fill.svg';
import ArrowUpSLineIcon from '../icons/arrow-up-s-line.svg';
import StickyNoteFillIcon from '../icons/sticky-note-fill.svg';
import SelectBoxFillIcon from '../icons/select-box-fill.svg';
import GroupLineIcon from '../icons/group-line.svg';
import TimeLineIcon from '../icons/time-line.svg';
import MenuLineIcon from '../icons/menu-line.svg';
import Inbox2LineIcon from '../icons/inbox-2-line.svg';
import InboxLineIcon from '../icons/inbox-line.svg';
import MailSentFillIcon from '../icons/mail-sent-fill.svg';
import DraftLineIcon from '../icons/draft-line.svg';
import DraftFillIcon from '../icons/draft-fill.svg';
import TimelineViewIcon from '../icons/timeline-view.svg';
import MailOpenLineIcon from '../icons/mail-open-line.svg';
import MailStarFillIcon from '../icons/mail-star-fill.svg';
import User3LineIcon from '../icons/user-3-line.svg';
import FilterLineIcon from '../icons/filter-line.svg';
import FileTransferLineIcon from '../icons/file-transfer-line.svg';
import PencilLineIcon from '../icons/pencil-line.svg';
import DeleteBinLineIcon from '../icons/delete-bin-line.svg';
import DeleteBinFillIcon from '../icons/delete-bin-fill.svg';
import ListSettingsLineIcon from '../icons/list-settings-line.svg';
import ListUnorderedIcon from '../icons/list-unordered.svg';
import ListOrderedIcon from '../icons/list-ordered.svg';
import ArrowLeftDoubleFillIcon from '../icons/arrow-left-double-fill.svg';
import PlayList2LineIcon from '../icons/play-list-2-line.svg';
import Exchange2LineIcon from '../icons/exchange-2-line.svg';
import CloseFillIcon from '../icons/close-fill.svg';
import PieChartLineIcon from '../icons/pie-chart-line.svg';
import FileListLine3Icon from '../icons/file-list-line-3.svg';
import DownloadLineIcon from '../icons/download-line.svg';
import VideoLineIcon from '../icons/video-line.svg';
import FacebookIcon from '../icons/facebook.svg';
import UserFollowFillIcon from '../icons/user-follow-fill.svg';
import UserFollowLineIcon from '../icons/user-follow-line.svg';
import UserUnfollowFillIcon from '../icons/user-unfollow-fill.svg';
import UserMinusFillIcon from '../icons/user-minus-fill.svg';
import Message2LineIcon from '../icons/message-2-line.svg';
import PokerDiamondsLineIcon from '../icons/poker-diamonds-line.svg';
import PokerDiamondsFillIcon from '../icons/poker-diamonds-fill.svg';
import ExpandDiagonalLineIcon from '../icons/expand-diagonal-line.svg';
import LinkedinFillIcon from '../icons/linkedin-fill.svg';
import LinkedinPremiumIcon from '../icons/linkedin-premium.svg';
import LinkedinLineIcon from '../icons/linkedin-line.svg';
import ImessageColorIcon from '../icons/imessage-color.svg';
import GmailColorIcon from '../icons/gmail-color.svg';
import GmailMainColorIcon from '../icons/gmail-main-color.svg';
import DraggableIcon from '../icons/draggable.svg';
import FocusModeIcon from '../icons/focus-mode.svg';
import HandIcon from '../icons/hand.svg';
import FullscreenExitLineIcon from '../icons/fullscreen-exit-line.svg';
import BookOpenLineIcon from '../icons/book-open-line.svg';
import ArrowDownSFillFullIcon from '../icons/arrow-down-s-fill-full.svg';
import ZoomInLineIcon from '../icons/zoom-in-line.svg';
import ZoomOutLineIcon from '../icons/zoom-out-line.svg';
import ImportLineIcon from '../icons/import-line.svg';
import ShareBoxFillIcon from '../icons/share-box-fill.svg';
import SortDescIcon from '../icons/sort-desc.svg';
import MatticAiIcon from '../icons/mattic-ai.svg';
import PlayListAddFillIcon from '../icons/play-list-add-fill.svg';
import FacebookCircleFillIcon from '../icons/facebook-circle-fill.svg';
import LinkedinBoxFillIcon from '../icons/linkedin-box-fill.svg';
import Database2LineIcon from '../icons/database-2-line.svg';
import CircleFillIcon from '../icons/circle-fill.svg';
import ExportLine from '../icons/export-line.svg';
import ErrorWarningFillIcon from '../icons/error-warning-fill.svg';
import VisitorIcon from '../icons/windows-2-line.svg';
import CompanyRemoveIcon from '../icons/company-remove.svg';
import HubspotFillIcon from '../icons/hubspot.svg';
import SalesforceIcon from '../icons/salesforce.svg';
import AttioIcon from '../icons/attio.svg';
import PipedriveIcon from '../icons/pipedrive.svg';
import TwentyIcon from '../icons/twenty.svg';
import CloseIcon from '../icons/close.svg';
import SaveLineIcon from '../icons/save-line.svg';
import TerminalBoxLineIcon from '../icons/terminal-box-line.svg';
import Spam3LineIcon from '../icons/spam-3-line.svg';
import InboxUnarchiveFillIcon from '../icons/inbox-unarchive-fill.svg';
import InstallLineIcon from '../icons/install-line.svg';
import InboxArchiveLineIcon from '../icons/inbox-archive-line.svg';
import AlertFillIcon from '../icons/alert-fill.svg';
import FlashlightFillIcon from '../icons/flashlight-fill.svg';
import InformationLineIcon from '../icons/information-line.svg';
import CustomerServiceLineIcon from '../icons/customer-service-line.svg';
import UserShared2LineIcon from '../icons/user-shared-2-line.svg';
import ShakeHandsLineIcon from '../icons/shake-hands-line.svg';
import CoinLineIcon from '../icons/coin-line.svg';
import CurrencyLineIcon from '../icons/currency-line.svg';
import Prohibited2LineIcon from '../icons/prohibit-2-line.svg';
import UserUnfollowLineIcon from '../icons/user-unfollow-line.svg';
import CircleLineIcon from '../icons/circle-line.svg';

export type IconName =
  | 'android'
  | 'add-company'
  | 'enrich-company'
  | 'enrich-company-tick'
  | 'account-circle-fill'
  | 'add-fill'
  | 'alert-fill'
  | 'anchor-line'
  | 'arrow-down-s-fill'
  | 'arrow-down-s-fill-full'
  | 'arrow-up-s-line'
  | 'arrow-up'
  | 'arrow-left-s-line'
  | 'arrow-right-down-line'
  | 'arrow-right-up-line'
  | 'arrow-up-double-line'
  | 'arrow-down-s-line'
  | 'ai-generate'
  | 'ai-summary-icon'
  | 'arrow-clockwise'
  | 'arrow-counter-clockwise'
  | 'arrow-right-long-fill'
  | 'arrow-left-line'
  | 'archive-line'
  | 'archive-fill'
  | 'inbox-archive-line'
  | 'arrow-go-back-line'
  | 'arrow-go-forward-line'
  | 'bar-chart'
  | 'bard-fill'
  | 'bell'
  | 'book-open'
  | 'book-3-line'
  | 'book-read-line'
  | 'book-line'
  | 'box-3-line'
  | 'bank-line'
  | 'brave'
  | 'brain-line'
  | 'building'
  | 'building-line'
  | 'building-3-fill'
  | 'building-3-line'
  | 'building-4-line'
  | 'building-4-fill'
  | 'briefcase-4-line'
  | 'building-4-line-alt'
  | 'calendar'
  | 'calendar-check-fill'
  | 'calendar-event-fill'
  | 'calendar-event-line'
  | 'calendar-fill'
  | 'calendar-line'
  | 'calendar-schedule-line'
  | 'calendar-schedule-fill'
  | 'calendar-todo-line'
  | 'calendar-check-line'
  | 'calendar-2-line'
  | 'cash-line'
  | 'chat-history-line'
  | 'chat-mattic'
  | 'chat'
  | 'chat-check-fill'
  | 'chat-4-line'
  | 'chat-3-line'
  | 'coin-fill'
  | 'customer-service-fill'
  | 'chat-gpt'
  | 'chat-forward-line'
  | 'chat-star'
  | 'chart-legend-dot'
  | 'check'
  | 'chat-unread-line'
  | 'chat-settings-line'
  | 'check-double-fill'
  | 'check-circle-fill'
  | 'chevron-down'
  | 'chevron-right'
  | 'chrome'
  | 'code-line'
  | 'computer-line'
  | 'computer-fill'
  | 'contacts-line'
  | 'contacts-book-2-line'
  | 'cross-fill'
  | 'crosshair-line'
  | 'close-circle-line'
  | 'close-circle-fill'
  | 'cursor-fill'
  | 'currency-fill'
  | 'database-line'
  | 'dot'
  | 'dot-large'
  | 'donut-chart-line'
  | 'delete'
  | 'draft'
  | 'edit-box-line'
  | 'ellipse'
  | 'eye-line'
  | 'eye-chat'
  | 'edge'
  | 'facebook-filled'
  | 'facebook-fill'
  | 'twitter-fill'
  | 'firefox'
  | 'file-line'
  | 'file-2-line'
  | 'file-add-line'
  | 'file-chart-line'
  | 'file-copy-line'
  | 'file-doc'
  | 'file-docx'
  | 'file-pdf'
  | 'file-jpg'
  | 'file-png'
  | 'file-csv'
  | 'file-gif'
  | 'file-mov'
  | 'file-mp4'
  | 'file-ppt'
  | 'file-pptx'
  | 'file-txt'
  | 'file-xls'
  | 'file-xlsx'
  | 'file-zip'
  | 'folder-line'
  | 'forbid-fill'
  | 'forbid-2-line'
  | 'focus-2-line'
  | 'focus-2-fill'
  | 'flag-line'
  | 'flag-fill'
  | 'flashlight-line'
  | 'flow-chart'
  | 'full-screen-line'
  | 'gemini'
  | 'global-line'
  | 'global-fill'
  | 'google-calendar'
  | 'google'
  | 'outlook'
  | 'gmail'
  | 'group-3-fill'
  | 'hand-coin-line'
  | 'help-center'
  | 'home-line'
  | 'ios'
  | 'information-fill'
  | 'information-line'
  | 'intermediate-circle-line'
  | 'indeterminate-circle-fill'
  | 'industry-fill'
  | 'linkedin'
  | 'linkedin-filled'
  | 'linkedin-line'
  | 'list-check-2'
  | 'list-unordered'
  | 'list-ordered'
  | 'loading'
  | 'loader-2-fill'
  | 'lock'
  | 'lock-line'
  | 'lock-unlock-line'
  | 'logout'
  | 'login-box-line'
  | 'logout-box-fill'
  | 'logout-box-r-fill'
  | 'logo-square'
  | 'loop-right-line'
  | 'linux'
  | 'journal-text'
  | 'justify'
  | 'mac'
  | 'mac-fill'
  | 'mail'
  | 'mail-fill'
  | 'mail-forbid-fill'
  | 'mail-line'
  | 'mail-star-line'
  | 'mail-add-line'
  | 'mail-check-line'
  | 'mail-download-line'
  | 'mail-upload-line'
  | 'mail-upload-fill'
  | 'mail-close-line'
  | 'mail-send-line'
  | 'map-fill'
  | 'map-pin-line'
  | 'map-pin-2-line'
  | 'menu-search-line'
  | 'money-dollar-circle-line'
  | 'microsoft'
  | 'more'
  | 'opera'
  | 'onboaring'
  | 'p2p-line'
  | 'pages-line'
  | 'parent-line'
  | 'pause'
  | 'pause-fill'
  | 'perplexity'
  | 'phone'
  | 'phone-fill'
  | 'play-line'
  | 'play-fill'
  | 'puzzle-2-line'
  | 'prohibited-2-fill'
  | 'progress-2-line'
  | 'price-tag-2-line'
  | 'price-tag-2-fill'
  | 'question-answer-fill'
  | 'question-line'
  | 'rectangle-line'
  | 'reply-line'
  | 'reply-all-line'
  | 'repeat-line'
  | 'logo-sidebar'
  | 'logo-nav'
  | 'planet-line'
  | 'safari'
  | 'search'
  | 'search-line'
  | 'select-box'
  | 'select-box-line'
  | 'select-box-circle-fill'
  | 'settings'
  | 'settings-2-line'
  | 'settings-user'
  | 'spy-line'
  | 'store-3-fill'
  | 'star-fill'
  | 'shuffle-line'
  | 'timer-2-line'
  | 'shakehand'
  | 'shakehand-fill'
  | 'shapes-fill'
  | 'share-forward-line'
  | 'sort-desc'
  | 'send-plane-line'
  | 'slack'
  | 'slack-filled'
  | 'slack-logo'
  | 'speak-ai-line'
  | 'stop-fill'
  | 'survey-line'
  | 'simple-loader'
  | 'signal-tower-line'
  | 'todo-line'
  | 'target'
  | 'team-line'
  | 'text-center'
  | 'text-left'
  | 'text-paragraph'
  | 'text-right'
  | 'time-fill'
  | 'type-bold'
  | 'type-italic'
  | 'type-strikethrough'
  | 'type-underline'
  | 'text'
  | 'trophy-fill'
  | 'user-6-line'
  | 'user-2-fill'
  | 'user-3-fill'
  | 'user-fill'
  | 'user-shared-2-fill'
  | 'user-add-line'
  | 'user-search-line'
  | 'user-minus-line'
  | 'user-settings-line'
  | 'verified-fill'
  | 'emotion-sad-line'
  | 'webhook-logo'
  | 'windows'
  | 'windows-fill'
  | 'new-chat'
  | 'history'
  | 'more'
  | 'attachment'
  | 'mic'
  | 'voice-print'
  | 'upload-cloud-line'
  | 'link'
  | 'pencil-line-email'
  | 'pencil-fill'
  | 'upload-cloud-2-line'
  | 'file-text-line'
  | 'x-filled'
  | 'filter-3-fill'
  | 'cross-hair-2'
  | 'node-tree'
  | 'square-line'
  | 'square-fill'
  | 'question-answer-line'
  | 'double-quotes-l'
  | 'ai-generate-2'
  | 'apps-2-line'
  | 'apps-2-add-line'
  | 'layout-grid-line'
  | 'refresh-line'
  | 'subtract-fill'
  | 'sticky-note-fill'
  | 'select-box-fill'
  | 'group-line'
  | 'time-line'
  | 'task-line'
  | 'menu-line'
  | 'todo-line'
  | 'survey-line'
  | 'inbox-2-line'
  | 'inbox-line'
  | 'mail-sent-fill'
  | 'draft-line'
  | 'draft-fill'
  | 'timeline-view'
  | 'mail-open-line'
  | 'mail-star-fill'
  | 'user-3-line'
  | 'filter-line'
  | 'file-transfer-line'
  | 'pencil-line'
  | 'delete-bin-line'
  | 'delete-bin-fill'
  | 'list-settings-line'
  | 'arrow-left-double-fill'
  | 'play-list-2-line'
  | 'play-large-fill'
  | 'exchange-2-line'
  | 'close-fill'
  | 'pie-chart-line'
  | 'file-list-line-3'
  | 'select-box-circle-line'
  | 'download-line'
  | 'video-line'
  | 'facebook'
  | 'user-unfollow-fill'
  | 'user-minus-fill'
  | 'user-follow-fill'
  | 'user-follow-line'
  | 'message-2-line'
  | 'poker-diamonds-line'
  | 'poker-diamonds-fill'
  | 'expand-diagonal-line'
  | 'collapse-diagonal-line'
  | 'linkedin-fill'
  | 'linkedin-premium'
  | 'linkedin-color'
  | 'gmail-color'
  | 'gmail-main-color'
  | 'imessage-color'
  | 'draggable'
  | 'focus-mode'
  | 'hand'
  | 'fullscreen-exit-line'
  | 'book-open-line'
  | 'zoom-in-line'
  | 'zoom-out-line'
  | 'import-line'
  | 'share-box-fill'
  | 'mattic-ai'
  | 'play-list-add-fill'
  | 'facebook-circle-fill'
  | 'linkedin-box-fill'
  | 'database-2-line'
  | 'circle-fill'
  | 'export-line'
  | 'error-warning-fill'
  | 'visitor'
  | 'company-remove'
  | 'hubspot'
  | 'salesforce'
  | 'attio'
  | 'pipedrive'
  | 'twenty'
  | 'close'
  | 'save-line'
  | 'terminal-box-line'
  | 'spam-3-line'
  | 'inbox-unarchive-fill'
  | 'install-line'
  | 'flashlight-fill'
  | 'coin-line'
  | 'information-line'
  | 'customer-service-line'
  | 'time-line'
  | 'user-shared-2-line'
  | 'shake-hands-line'
  | 'currency-line'
  | 'prohibited-2-line'
  | 'user-unfollow-line'
  | 'user-minus-line'
  | 'circle-line';

const iconComponents: Record<IconName, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  android: AndroidIcon,
  'add-company': AddCompanyIcon,
  'enrich-company': EnrichCompanyIcon,
  'enrich-company-tick': EnrichCompanyTickIcon,
  'account-circle-fill': AccountCircleFillIcon,
  'add-fill': AddFillIcon,
  'alert-fill': AlertFillIcon,
  'apps-2-line': Apps2LineIcon,
  'apps-2-add-line': Apps2AddLineIcon,
  'anchor-line': AnchorLineIcon,
  'time-line': TimeLineIcon,
  'refresh-line': RefreshLineIcon,
  'sticky-note-fill': StickyNoteFillIcon,
  'select-box-fill': SelectBoxFillIcon,
  'select-box-circle-fill': SelectBoxCircleFillIcon,
  'menu-line': MenuLineIcon,
  'task-line': TaskLineIcon,
  'todo-line': TodoLineIcon,
  'survey-line': SurveyLineIcon,
  'pencil-line': PencilLineIcon,
  'arrow-left-double-fill': ArrowLeftDoubleFillIcon,
  'arrow-down-s-fill': ArrowDownSFillIcon,
  'arrow-down-s-fill-full': ArrowDownSFillFullIcon,
  'arrow-up-s-line': ArrowUpSLineIcon,
  'arrow-up': ArrowUpIcon,
  'arrow-left-s-line': ArrowLeftSLineIcon,
  'arrow-right-down-line': ArrowRightDownLineIcon,
  'arrow-right-up-line': ArrowRightUpLineIcon,
  'arrow-up-double-line': ArrowUpDoubleLineIcon,
  'arrow-down-s-line': ArrowDownSLineIcon,
  'ai-generate': AIGenerateIcon,
  'ai-summary-icon': AISummaryIcon,
  'arrow-clockwise': ArrowClockwiseIcon,
  'arrow-counter-clockwise': ArrowCounterClockwiseIcon,
  'arrow-right-long-fill': ArrowRightLongFillIcon,
  'arrow-left-line': ArrowLeftLineIcon,
  'archive-line': ArchiveLineIcon,
  'archive-fill': ArchiveFillIcon,
  'inbox-archive-line': InboxArchiveLineIcon,
  'arrow-go-back-line': ArrowGoBackLineIcon,
  'arrow-go-forward-line': ArrowGoForwardLineIcon,
  'bar-chart': BarChartIcon,
  'bard-fill': BardFillIcon,
  bell: BellIcon,
  'book-open': BookOpenIcon,
  'book-3-line': Book3LineIcon,
  'book-read-line': BookReadLineIcon,
  'box-3-line': Box3LineIcon,
  'bank-line': BankLineIcon,
  brave: BraveIcon,
  'brain-line': BrainLineIcon,
  building: Building4LineIcon,
  'building-line': BuildingLineIcon,
  'building-3-fill': Building3FillIcon,
  'building-3-line': Building3LineIcon,
  'building-4-line': Building4LineIcon,
  'building-4-fill': Building4FillIcon,
  'briefcase-4-line': Briefcase4LineIcon,
  'building-4-line-alt': Building4LineAltIcon,
  'cash-line': CashLineIcon,
  calendar: CalendarIcon,
  'calendar-check-fill': CalendarCheckFillIcon,
  'calendar-event-fill': CalendarEventFillIcon,
  'calendar-event-line': CalendarEventLineIcon,
  'calendar-fill': CalendarFillIcon,
  'calendar-line': CalendarLineIcon,
  'calendar-schedule-line': CalendarScheduleLineIcon,
  'calendar-schedule-fill': CalendarScheduleFillIcon,
  'calendar-todo-line': CalendarTodoLineIcon,
  'calendar-2-line': Calendar2LineIcon,
  'calendar-check-line': CalendarCheckLineIcon,
  'chat-4-line': Chat4LineIcon,
  'chat-3-line': Chat3LineIcon,
  'coin-fill': CoinFillIcon,
  'customer-service-fill': CustomerServiceFillIcon,
  'chart-legend-dot': ChartLegendDotIcon,
  'chat-unread-line': ChatUnreadLineIcon,
  'chat-settings-line': ChatSettingsLineIcon,
  'contacts-book-2-line': ContactsBook2LineIcon,
  'close-fill': CloseFillIcon,
  'close-circle-line': CloseCircleLineIcon,
  'collapse-diagonal-line': CollapseDiagonalLineIcon,
  'download-line': DownloadLineIcon,
  'journal-text': JournalTextIcon,
  justify: JustifyIcon,
  'text-center': TextCenterIcon,
  'text-left': TextLeftIcon,
  'text-right': TextRightIcon,
  'text-paragraph': TextParagraphIcon,
  'type-bold': TypeBoldIcon,
  'type-italic': TypeItalicIcon,
  'type-strikethrough': TypeStrikethroughIcon,
  'type-underline': TypeUnderlineIcon,
  text: TextIcon,
  'chat-check-fill': ChatCheckFillIcon,
  'chat-gpt': ChatGptIcon,
  'chat-history-line': ChatHistoryLineIcon,
  'chat-mattic': ChatIcon,
  'chat-forward-line': ChatForwardLineIcon,
  'chat-star': ChatStarIcon,
  chat: ChatNewLineIcon,
  chrome: ChromeIcon,
  check: CheckIcon,
  'check-circle-fill': CheckCircleFillIcon,
  'chevron-down': ChevronDownLineIcon,
  'chevron-right': ChevronRightIcon,
  'code-line': CodeLineIcon,
  'computer-line': ComputerLineIcon,
  'computer-fill': ComputerFillIcon,
  'contacts-line': ContactsLineIcon,
  'cross-fill': CrossFillIcon,
  'crosshair-line': CrossHairLineIcon,
  'close-circle-fill': CloseCircleFillIcon,
  'check-double-fill': CheckDoubleFillIcon,
  'cursor-fill': CursorFillIcon,
  'currency-fill': CurrencyFillIcon,
  'database-line': DatabaseLineIcon,
  delete: DeleteIcon,
  dot: DotIcon,
  'dot-large': DotLargeIcon,
  'donut-chart-line': DonutChartLineIcon,
  draft: DraftIcon,
  'edit-box-line': EditBoxLineIcon,
  ellipse: EllipseIcon,
  'eye-line': EyeLineIcon,
  'eye-chat': EyeChatIcon,
  edge: EdgeIcon,
  'facebook-filled': FacebookFilledIcon,
  'facebook-fill': FacebookFillIcon,
  'twitter-fill': TwitterFillIcon,
  firefox: FirefoxIcon,
  'file-doc': FileDocIcon,
  'file-docx': FileDocxIcon,
  'file-pdf': FilePdfIcon,
  'file-jpg': FileJpgIcon,
  'file-png': FilePngIcon,
  'file-line': FileLineIcon,
  'focus-2-line': Focus2LineIcon,
  'file-2-line': File2LineIcon,
  'file-add-line': FileAddLineIcon,
  'file-chart-line': FileChartLineIcon,
  'file-copy-line': FileCopyLineIcon,
  'file-csv': FileCsvIcon,
  'file-gif': FileGifIcon,
  'file-mov': FileMovIcon,
  'file-mp4': FileMp4Icon,
  'file-ppt': FilePptIcon,
  'file-pptx': FilePptxIcon,
  'file-txt': FileTxtIcon,
  'file-xls': FileXlsIcon,
  'file-xlsx': FileXlsxIcon,
  'file-zip': FileZipIcon,
  'folder-line': FolderLineIcon,
  'forbid-fill': ForbidFillIcon,
  'forbid-2-line': Forbid2LineIcon,
  'flag-line': FlagLineIcon,
  'flag-fill': FlagFillIcon,
  'flashlight-line': FlashlightLineIcon,
  'flow-chart': FlowChartIcon,
  'full-screen-line': FullScreenLineIcon,
  'focus-2-fill': Focus2FillIcon,
  gemini: GeminiIcon,
  'global-line': GlobalLineIcon,
  'global-fill': GlobalFillIcon,
  'google-calendar': GoogleCalendarIcon,
  google: GoogleIcon,
  outlook: OutlookIcon,
  gmail: GmailIcon,
  'group-3-fill': Group3FillIcon,
  'hand-coin-line': HandCoinLineIcon,
  'help-center': HelpCenterIcon,
  'home-line': HomeLineIcon,
  ios: IosIcon,
  'information-fill': InformationFillIcon,
  'information-line': InformationLineIcon,
  'intermediate-circle-line': IntermediateCircleLineIcon,
  'indeterminate-circle-fill': IndeterminateCircleFillIcon,
  'industry-fill': IndustryFillIcon,
  linkedin: LinkedinIcon,
  'linkedin-filled': LinkedinFilledIcon,
  'list-check-2': ListCheck2Icon,
  'list-unordered': ListUnorderedIcon,
  'list-ordered': ListOrderedIcon,
  loading: LoadingIcon,
  'loader-2-fill': Loader2FillIcon,
  lock: LockIcon,
  'lock-line': LockLineIcon,
  'lock-unlock-line': LockUnlockLineIcon,
  'logo-sidebar': LogoSidebarIcon,
  'logo-nav': LogoNavIcon,
  'login-box-line': LoginBoxLineIcon,
  logout: LogoutIcon,
  'logout-box-fill': LogoutBoxFillIcon,
  'logout-box-r-fill': LogoutBoxRFillIcon,
  'loop-right-line': LoopRightLineIcon,
  'logo-square': LogoSquareIcon,
  mac: MacIcon,
  'mac-fill': MacFillIcon,
  mail: MailIcon,
  'mail-line': MailLineIcon,
  'mail-fill': MailFillIcon,
  'mail-forbid-fill': MailForbidFillIcon,
  'mail-star-line': MailStarLineIcon,
  'mail-add-line': MailAddLineIcon,
  'mail-check-line': MailCheckLineIcon,
  'mail-download-line': MailDownloadLineIcon,
  'mail-upload-line': MailUploadLineIcon,
  'mail-upload-fill': MailUploadFillIcon,
  'mail-close-line': MailCloseLineIcon,
  'mail-send-line': MailSendLineIcon,
  'map-fill': MapFillIcon,
  'map-pin-line': MapPinLineIcon,
  'map-pin-2-line': MapPin2LineIcon,
  'menu-search-line': MenuSearchLineIcon,
  'money-dollar-circle-line': MoneyDollarCircleLineIcon,
  microsoft: MicrosoftIcon,
  more: More2LineIcon,
  onboaring: OnboaringIcon,
  opera: OperaIcon,
  'p2p-line': P2pLineIcon,
  'pages-line': PagesLineIcon,
  'parent-line': ParentLineIcon,
  pause: PauseLineIcon,
  'pause-fill': PauseFillIcon,
  perplexity: PerplexityIcon,
  phone: PhoneIcon,
  'phone-fill': PhoneFillIcon,
  'play-line': PlayLineIcon,
  'play-fill': PlayFillIcon,
  'play-large-fill': PlayLargeFillIcon,
  'planet-line': PlanetLineIcon,
  'puzzle-2-line': Puzzle2LineIcon,
  'prohibited-2-fill': Prohibited2FillIcon,
  'price-tag-2-line': PriceTag2LineIcon,
  'price-tag-2-fill': PriceTag2FillIcon,
  'progress-2-line': Progress2LineIcon,
  'question-answer-line': QuestionAnswerLineIcon,
  'question-answer-fill': QuestionAnswerFillIcon,
  'question-line': QuestionLineIcon,
  'rectangle-line': RectangleLineIcon,
  'reply-line': ReplyLineIcon,
  'reply-all-line': ReplyAllLineIcon,
  'repeat-line': RepeatLineIcon,
  safari: SafariIcon,
  search: SearchIcon,
  'search-line': SearchLineIcon,
  'select-box': SelectBoxIcon,
  'select-box-line': SelectBoxLineIcon,
  settings: SettingsIcon,
  'settings-2-line': Settings2LineIcon,
  'settings-user': SettingsUserIcon,
  'spy-line': SpyLineIcon,
  'store-3-fill': Store3FillIcon,
  'star-fill': StarFillIcon,
  'timer-2-line': Timer2LineIcon,
  shakehand: ShakehandIcon,
  'shakehand-fill': ShakehandFillIcon,
  'shapes-fill': ShapesFillIcon,
  'share-forward-line': ShareForwardLineIcon,
  'sort-desc': SortDescIcon,
  'send-plane-line': SendPlaneLineIcon,
  slack: SlackIcon,
  'slack-filled': SlackFilledIcon,
  'slack-logo': SlackLogoIcon,
  'speak-ai-line': SpeakAIIcon,
  'stop-fill': StopFillIcon,
  'simple-loader': SimpleLoaderIcon,
  'signal-tower-line': SignalTowerIcon,
  'select-box-circle-line': SelectBoxCircleLineIcon,
  'shuffle-line': ShuffleLineIcon,
  target: TargetIcon,
  'team-line': TeamLineIcon,
  'time-fill': TimeFillIcon,
  'trophy-fill': TrophyFillIcon,
  'verified-fill': VerifiedFillIcon,
  'emotion-sad-line': EmotionSadLineIcon,
  'user-6-line': User6LineIcon,
  'user-2-fill': User2FillIcon,
  'user-3-fill': User3FillIcon,
  'user-fill': UserFillIcon,
  'user-shared-2-fill': userShared2Fill,
  'user-search-line': UserSearchLineIcon,
  'user-minus-line': UserMinusLineIcon,
  'user-settings-line': UserSettingsLineIcon,
  'webhook-logo': WebhookLogoIcon,
  windows: WindowsIcon,
  'windows-fill': WindowsFillIcon,
  'new-chat': NewChatIcon,
  history: HistoryIcon,
  attachment: AttachmentIcon,
  mic: MicIcon,
  'voice-print': VoicePrintIcon,
  'upload-cloud-line': UploadCloudLineIcon,
  link: LinkIcon,
  'pencil-fill': PencilFillIcon,
  'pencil-line-email': PencilLineEmailIcon,
  'upload-cloud-2-line': UploadCloud2LineIcon,
  'file-text-line': FileTextLineIcon,
  linux: LinuxIcon,
  'x-filled': XFilledIcon,
  'filter-3-fill': Filter3FillIcon,
  'cross-hair-2': CrossHair2Icon,
  'node-tree': NodeTreeIcon,
  'square-line': SquareLineIcon,
  'square-fill': SquareFillIcon,
  'double-quotes-l': DoubleQuotesLIcon,
  'ai-generate-2': AIGenerate2Icon,
  'layout-grid-line': LayoutGridLineIcon,
  'subtract-fill': SubtractFillIcon,
  'group-line': GroupLineIcon,
  'inbox-2-line': Inbox2LineIcon,
  'inbox-line': InboxLineIcon,
  'mail-sent-fill': MailSentFillIcon,
  'draft-line': DraftLineIcon,
  'draft-fill': DraftFillIcon,
  'timeline-view': TimelineViewIcon,
  'mail-open-line': MailOpenLineIcon,
  'mail-star-fill': MailStarFillIcon,
  'user-3-line': User3LineIcon,
  'user-add-line': UserAddLineIcon,
  'filter-line': FilterLineIcon,
  'file-transfer-line': FileTransferLineIcon,
  'delete-bin-line': DeleteBinLineIcon,
  'delete-bin-fill': DeleteBinFillIcon,
  'list-settings-line': ListSettingsLineIcon,
  'play-list-2-line': PlayList2LineIcon,
  'exchange-2-line': Exchange2LineIcon,
  'pie-chart-line': PieChartLineIcon,
  'file-list-line-3': FileListLine3Icon,
  'video-line': VideoLineIcon,
  facebook: FacebookIcon,
  'user-follow-fill': UserFollowFillIcon,
  'user-follow-line': UserFollowLineIcon,
  'user-unfollow-fill': UserUnfollowFillIcon,
  'user-minus-fill': UserMinusFillIcon,
  'message-2-line': Message2LineIcon,
  'poker-diamonds-line': PokerDiamondsLineIcon,
  'poker-diamonds-fill': PokerDiamondsFillIcon,
  'expand-diagonal-line': ExpandDiagonalLineIcon,
  'linkedin-fill': LinkedinFillIcon,
  'linkedin-line': LinkedinLineIcon,
  'linkedin-premium': LinkedinPremiumIcon,
  'linkedin-color': LinkedinColorIcon,
  'imessage-color': ImessageColorIcon,
  'gmail-color': GmailColorIcon,
  'gmail-main-color': GmailMainColorIcon,
  draggable: DraggableIcon,
  'focus-mode': FocusModeIcon,
  hand: HandIcon,
  'fullscreen-exit-line': FullscreenExitLineIcon,
  'book-open-line': BookOpenLineIcon,
  'book-line': BookLineIcon,
  'zoom-in-line': ZoomInLineIcon,
  'zoom-out-line': ZoomOutLineIcon,
  'import-line': ImportLineIcon,
  'share-box-fill': ShareBoxFillIcon,
  'mattic-ai': MatticAiIcon,
  'play-list-add-fill': PlayListAddFillIcon,
  'facebook-circle-fill': FacebookCircleFillIcon,
  'linkedin-box-fill': LinkedinBoxFillIcon,
  'database-2-line': Database2LineIcon,
  'circle-fill': CircleFillIcon,
  'export-line': ExportLine,
  'error-warning-fill': ErrorWarningFillIcon,
  'company-remove': CompanyRemoveIcon,
  visitor: VisitorIcon,
  hubspot: HubspotFillIcon,
  salesforce: SalesforceIcon,
  attio: AttioIcon,
  pipedrive: PipedriveIcon,
  twenty: TwentyIcon,
  close: CloseIcon,
  'save-line': SaveLineIcon,
  'terminal-box-line': TerminalBoxLineIcon,
  'spam-3-line': Spam3LineIcon,
  'inbox-unarchive-fill': InboxUnarchiveFillIcon,
  'install-line': InstallLineIcon,
  'flashlight-fill': FlashlightFillIcon,
  'customer-service-line': CustomerServiceLineIcon,
  'user-shared-2-line': UserShared2LineIcon,
  'shake-hands-line': ShakeHandsLineIcon,
  'coin-line': CoinLineIcon,
  'currency-line': CurrencyLineIcon,
  'prohibited-2-line': Prohibited2LineIcon,
  'user-unfollow-line': UserUnfollowLineIcon,
  'circle-line': CircleLineIcon,
};

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
  size?: number;
  className?: string;
  color?: string;
  'aria-label'?: string;
}

const Icon: React.FC<IconProps> = ({
  name,
  size = 6,
  className = '',
  color = '',
  'aria-label': ariaLabel,
  ...props
}) => {
  const IconComponent = iconComponents[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }
  const sizeClass = `w-${size} h-${size}`;
  const spanClassName = `inline-flex shrink-0 ${sizeClass} ${color} ${className}`.trim();

  return (
    <span className={cn(spanClassName)}>
      <IconComponent
        data-name={name}
        aria-label={ariaLabel}
        {...props}
        className="!w-full !h-auto"
      />
    </span>
  );
};

export default Icon;
